import { defineComponent, onMounted, PropType, ref } from "vue";
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
interface Timeslot {
  name: string;
  time: string;
  caption?: string;
}
export default defineComponent({
  props: {
    timeslots: { type: Array as PropType<Timeslot[]>, required: true },
  },
  setup() {
    const illustrations = ref<HTMLElement | null>(null);

    onMounted(() => {
      const TL = gsap.timeline({
        scrollTrigger: {
          trigger: illustrations.value,
          start: "top 80%",
        },
      });

      const suns = illustrations.value!.querySelectorAll<HTMLElement>(
        ".openinghours__illustration"
      );

      suns!.forEach((sun, index) => {
        let endPercentage = 0;

        switch (index) {
          case 0:
            endPercentage = 60;
            break;
          case 1:
            endPercentage = 0;
            break;
          case 2:
            endPercentage = 30;
            break;
        }

        TL.fromTo(
          sun,
          { yPercent: 120 },
          { yPercent: endPercentage, ease: "power4.out", duration: 1.4 },
          (index + 1) * 0.4
        );
      });
    });

    return { illustrations };
  },
});
